import { reduxForm } from 'redux-form'

import validateHelper from '../validationHelper'

export const validate = (values, { fields }) => validateHelper(values, fields)

export default reduxForm({
  validate,
})
